import { Box, styled, Typography } from '@mui/material';
const VideoText = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.contrastText,
}));
const Video = styled(Box)(({ theme }) => ({
    aspectRatio: '4/5',
    [theme.breakpoints.up('sm')]: {
        aspectRatio: '1',
    },
    [theme.breakpoints.up('md')]: {
        aspectRatio: '16 / 9',
    },
}));
export const VideoContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    overflow: 'hidden',
    flexGrow: 1,
    borderRadius: theme.spacing(4),
    backgroundColor: theme.palette.grey[900],
    margin: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
        margin: theme.spacing(0),
    },
}));
export const ClinicianName = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(4),
    left: theme.spacing(4),
    zIndex: theme.zIndex.fab,
}));
export const ClinicianNameText = styled(VideoText)(({ theme }) => ({
    textShadow: '0.125rem 0.125rem 0.25rem rgba(0,0,0,1)',
    fontSize: '1.25rem',
    [theme.breakpoints.up('md')]: {
        fontSize: '1.5rem',
    },
}));
export const ClinicianVideo = styled(Video)({
    width: '100%',
});
export const ClinicianVideoDisabled = styled(Video)({
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
});
export const ClinicianVideoDisabledText = styled(VideoText)(({ theme }) => ({
    fontSize: '1rem',
    [theme.breakpoints.up('md')]: {
        fontSize: '1.25rem',
    },
}));
export const PatientVideo = styled(Video)(({ theme }) => ({
    position: 'absolute',
    overflow: 'hidden',
    minHeight: '9rem',
    bottom: theme.spacing(4),
    right: theme.spacing(4),
    borderRadius: theme.spacing(4),
    backgroundColor: theme.palette.grey[800],
    [theme.breakpoints.down('md')]: {
        maxWidth: '6rem',
    },
}));
export const PatientVideoDisabled = styled(Video)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.grey[800],
}));
export const PatientVideoDisabledText = styled(VideoText)(({ theme }) => ({
    textAlign: 'center',
    lineHeight: '1.25',
    fontSize: '0.75rem',
    [theme.breakpoints.up('md')]: {
        fontSize: '1.25rem',
    },
}));
export const PatientAudioInputLevel = styled(Box)(({ theme }) => ({
    position: 'absolute',
    left: '1.2em',
    bottom: '1.2em',
    [theme.breakpoints.up('md')]: {
        left: '1.5em',
        bottom: '1.5em',
    },
}));
export const ClinicianAudioInputLevel = styled(Box)(({ theme }) => ({
    position: 'absolute',
    left: '2em',
    bottom: '2em',
    [theme.breakpoints.up('md')]: {
        left: '3em',
        bottom: '3em',
    },
}));
//# sourceMappingURL=data:application/json;base64,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